import styled from 'styled-components';
import { Breakpoints, colorVariables } from '../../theme/Theme.constants';

export const PrivacyConditionsWrapper = styled.div``;

